export const bgColor = 'bg-gray-50'
export const isDark = true
export const mdWidth = 767
export const lgWidth = 1024
export const HeroHeaderText = `text-4xl sm:text-5xl md:text-6xl`
